@if (title) {
  <wb-heading size="l">{{ title | translate }}</wb-heading>
}
@if (showTabNavigation()) {
  <wb-tabs selected="{{ searchOptions.entity }}" theme="dark">
    @for (entity of entitiesWithContent; track entity) {
      <wb-tab (click)="openTab(entity)" name="{{ entity }}" selected="entity === searchOptions.entity"
        >{{ getEntityLabelKey(entity) | translate }}

        <span class="visually-hidden">{{ assetsCount[entity] || 0 }}</span>

        @if (isBrowser) {
          <wb-counter
            class="wb-margin-start-xxs"
            aria-hidden="true"
            [max]="9999"
            [value]="assetsCount[entity] || 0"
            theme="dark"
            variant="secondary"
          ></wb-counter>
        }
      </wb-tab>
    }
  </wb-tabs>
}

@if (!isError) {
  @if (filterGroups.length) {
    <div class="filter-background"></div>
    @if (searchOptions.entity) {
      <mb-filtertool-narrow
        [filterGroups]="filterGroups"
        [activeEntity]="searchOptions.entity"
        (allFiltersClickEvent)="showAll()"
      ></mb-filtertool-narrow>
    }
  }
  @if (searchOptions.entity) {
    <div class="info">
      <wb-text>{{ getEntityCountKey(searchOptions.entity, assetCount) | translate: { count: assetCount } }}</wb-text>
      <wb-select compact theme="dark">
        <select name="model" [ngModel]="searchOptions.sortOption" (ngModelChange)="onSortChange($event)">
          @for (sortOption of sortOptions; track sortOption.label) {
            <option [ngValue]="sortOption">
              {{ sortOption.label | translate }}
            </option>
          }
        </select>
      </wb-select>
    </div>
  }
  <wb-grid>
    <wb-grid-row>
      @if (cards.length) {
        @for (item of cards | slice: 0 : shownCardsCount; track item.id) {
          <wb-grid-col mq1="12" mq2="12" mq3="6" mq4="4" mq5="4" mq6="3">
            @switch (searchOptions.entity) {
              @case ('EVENT') {
                <mb-event-card
                  [titleHash]="item.titleHash"
                  [headline]="item.headline"
                  [image]="$any(item.media)"
                  [darkTheme]="true"
                  [link]="item.link"
                  [startDate]="item.startDate"
                  [endDate]="item.endDate"
                  [timezoneOffset]="item.timezoneOffset"
                  [location]="item.location"
                >
                </mb-event-card>
              }
              @default {
                <mb-media-card
                  [assetType]="item.type"
                  [headline]="item.headline!"
                  [media]="item.media"
                  [link]="item.link!"
                  [topline]="item.topline"
                  [toplineIcon]="item.toplineIcon"
                  [text]="item.text"
                  [metaItems]="item.metaItems"
                  [actions]="item.actions"
                  [data]="item"
                  [videoDuration]="item.videoDuration"
                  [assetCount]="item.assetCount"
                  [fuelLabel]="item.fuelLabel"
                  [displayDate]="item.displayDate"
                ></mb-media-card>
              }
            }
          </wb-grid-col>
        }
      } @else {
        @for (i of [].constructor(initialCardAmount); track $index) {
          <wb-grid-col mq1="12" mq2="12" mq3="6" mq4="4" mq5="4" mq6="3">
            <wb-skeleton class="card-skeleton" theme="dark"></wb-skeleton>
          </wb-grid-col>
        }
      }
    </wb-grid-row>
  </wb-grid>
  @if (assetCount) {
    <div class="bottom-buttons">
      @if (assetCount > shownCardsCount && (searchOptions.page || 0) < maxPages) {
        <wb-button (click)="showMore()" variant="secondary" theme="dark">{{ 'SHOW_MORE' | translate }}</wb-button>
      }
      @if (showShowAllButton) {
        <wb-button (click)="showAll()" variant="secondary" theme="dark"
          ><wb-icon slot="icon" name="bds/arrow-right/24"></wb-icon>{{ 'ALL' | translate }}
          {{ this.searchOptions.entity + 'S' | translate }}</wb-button
        >
      }
    </div>
  }
} @else {
  <wb-error-section>
    <wb-heading size="s" tag="h2">{{ 'AN_ERROR_OCCURED' | translate }}</wb-heading>
    <wb-text size="l" tag="p">
      {{ 'AN_ERROR_OCCURED_MESSAGE' | translate }}
    </wb-text>
    <wb-button (click)="reload()" theme="dark" slot="footer" variant="secondary" size="l">{{
      'RELOAD' | translate
    }}</wb-button>
  </wb-error-section>
}
